export namespace CssTypes {
	export type CssUnit = 'px' | 'vh' | 'vw' | '%' | 'em' | 'rem';

	// template example: '*px' for CssStringTemplate<'*'>
	export type CssStringTemplate<Placeholder extends string = ''> = `${string}${Placeholder}${string}${CssUnit}`;

	export function cssStringUnitToPixels(cssString: CssStringTemplate): number {
		const unit = cssString.match(/[a-z]+/)?.[0] as CssUnit;
		const value = parseFloat(cssString);
		const base: number = parseFloat(window.getComputedStyle(document.documentElement).fontSize);

		switch (unit) {
			case 'px':
				return value;
			case 'vh':
				return (window.innerHeight * value) / 100;
			case 'vw':
				return (window.innerWidth * value) / 100;
			case '%':
				return (base * value) / 100;
			case 'em':
				return base * value;
			case 'rem':
				return base * value;
			default:
				return 0;
		}
	}
}
